export default function ({ width = "22px", fill = "none" }) {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="scale(0.9)"
    >
      <g clipPath="url(#clip0_5154_15002)">
        <rect x="0.857422" width="24" height="24" rx="12" fill={fill} />
        <circle cx="12.8574" cy="12" r="4" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_5154_15002">
          <rect x="0.857422" width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
